import { Filter24Regular } from "@fluentui/react-icons";
import { Button } from "@fluentui/react-components";
import styles from "./SettingsButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    title?: string;
    activeCount?: number; // ✅ new optional prop
}

export const SettingsButton = ({ className, onClick, title, activeCount = 0 }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""}`} style={{ position: "relative" }}>
            <Button icon={<Filter24Regular />} onClick={onClick}>
                {title}
            </Button>

            {/* ✅ Show badge only when there are active filters */}
            {activeCount > 0 && <span className={styles.badge}>{activeCount}</span>}
        </div>
    );
};
